module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-right-bottom-backplates-remnants.d959ae66.png";